module.exports = __webpack_public_path__ + "assets/img/pjs_2.48f7a696.png";